import { z } from 'zod';
import { UserSchema } from '../../../../entities/user/user.schema';
/**
 * Send Tenant User Invitation Request Schema
 * POST /api/v2/tenants/:tenantId/users/:userId/send-invitation
 *
 * No request body needed - IDs come from URL params
 */ export const SendTenantUserInvitationRequestSchema = z.object({});
/**
 * Send Tenant User Invitation Response Schema
 * Returns the updated user with status changed to 'pending'
 */ export const SendTenantUserInvitationResponseSchema = z.object({
    data: UserSchema
});

//# sourceMappingURL=send-tenant-user-invitation.schema.js.map